import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { next } from '@ember/runloop';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

export interface NewItemOption {
	action: (e: PointerEvent) => void;
	icon: IconName;
	text: string;
}

interface Args {
	top?: NewItemOption;
	bottom?: NewItemOption;
	buttonText?: string;
	customOpenAction?: (e: PointerEvent) => boolean;
}

export default class CommonNewItemOptionsComponent extends Component<Args> {
	@tracked showingOptions = false;

	get isAvaibleOptionsShown(): boolean {
		return !!this.args.top && !!this.args.bottom;
	}

	@action
	showAvailableOptions(e: PointerEvent): void {
		if (this.showingOptions) {
			return;
		}

		const shouldShowOptions = this.args.customOpenAction ? this.args.customOpenAction(e) : true;

		if (shouldShowOptions) {
			const wrapper = document.getElementById('wrapper');
			if (wrapper) {
				const wrapperClickEventHandler = () => {
					this.showingOptions = false;
					wrapper.removeEventListener('click', wrapperClickEventHandler);
				};
				next(() => {
					wrapper.addEventListener('click', wrapperClickEventHandler);
				});
			}
			this.showingOptions = true;
		}
	}
	<template>
		<li
			role="button"
			class="card card--placeholder-new flex-item flex-item--placeholder filter-all
				{{if this.showingOptions 'card--placeholder-new-has-options'}}
				{{unless @buttonText 'no-button-text'}}"
			{{on "click" this.showAvailableOptions}}
		>
			<div class="default">
				<CommonUiIconComponent @name="Plus" @size="xl" />
				{{@buttonText}}
			</div>
			{{#if this.isAvaibleOptionsShown}}
				<div class="option">
					{{#if @top}}
						{{! template-lint-disable no-nested-interactive }}
						<div class="option__top" role="button" {{on "click" @top.action}}>
							<p class="option-text">
								<CommonUiIconComponent @name={{@top.icon}} @size="xl" />
								{{@top.text}}
							</p>
						</div>
					{{/if}}
					{{#if @bottom}}
						<hr />
						{{! template-lint-disable no-nested-interactive }}
						<div class="option__bottom" role="button" {{on "click" @bottom.action}}>
							<p class="option-text">
								<CommonUiIconComponent @name={{@bottom.icon}} @size="xl" />
								{{@bottom.text}}
							</p>
						</div>
					{{/if}}
				</div>
			{{/if}}
		</li>
	</template>
}
